import { getAddAccountCampaignStore } from "../store/AddAccountCampaignStore";
import type { AddAccountCampaignViewState } from "../store/schema/addAccountCampaignState";

export const getAddAccountCampaignViewState = (): AddAccountCampaignViewState => {
    return getAddAccountCampaignStore().viewState;
};

export interface AccountCampaignDetails {
    titleText: string;
    bodyText: string;
    ctaText: string;
    imageVariant: string;
    trackingBaseUri: string | undefined;
    impressionBaseUri: string | undefined;
}

export const getAddAccountCampaignDetails = (): AccountCampaignDetails => {
    const { titleText, bodyText, ctaText, imageVariant, trackingBaseUri, impressionBaseUri } = getAddAccountCampaignStore();
    return {
        titleText,
        bodyText,
        ctaText,
        imageVariant,
        trackingBaseUri,
        impressionBaseUri,
    };
};
